import React, { useEffect, useState } from "react";
import { ShieldCheck } from "lucide-react";
import { getConsent, setConsent } from "../lib/consent";

/* Consent Mode v2 banner — GDPR/AU-friendly. Shows once until a choice is made. */
export const ConsentBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!getConsent()) {
      const t = setTimeout(() => setVisible(true), 800);
      return () => clearTimeout(t);
    }
  }, []);

  const choose = (granted) => {
    setConsent(granted);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="consent-banner"
      role="dialog"
      aria-label="Cookie and tracking consent"
      className="fixed bottom-4 inset-x-4 sm:left-6 sm:right-auto z-[200] sm:max-w-md rounded-sm border border-hair-dark bg-[#0C1B2E] text-white shadow-2xl"
    >
      <div className="p-5 lg:p-6">
        <div className="flex items-center gap-2">
          <ShieldCheck className="h-4 w-4 text-teal shrink-0" />
          <p className="eyebrow text-teal">Your privacy</p>
        </div>
        <p className="mt-3 text-white/75 text-sm leading-relaxed">
          We use cookies and similar tools to measure traffic and improve our marketing. You can accept
          analytics &amp; advertising cookies, or continue with only what's essential.{" "}
          <a
            href="https://www.axiomcollege.com.au/privacy-policy/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-teal font-semibold hover:underline"
          >
            Privacy Policy
          </a>
          .
        </p>
        <div className="mt-5 flex flex-col sm:flex-row gap-3">
          <button
            data-testid="consent-accept"
            onClick={() => choose(true)}
            className="flex-1 bg-teal text-white font-display font-semibold text-sm rounded-sm px-5 py-3 hover:bg-[#08929f] transition-colors focus-ring"
          >
            Accept all
          </button>
          <button
            data-testid="consent-reject"
            onClick={() => choose(false)}
            className="flex-1 border border-hair-dark text-white/90 font-display font-semibold text-sm rounded-sm px-5 py-3 hover:bg-white/5 transition-colors focus-ring"
          >
            Essential only
          </button>
        </div>
      </div>
    </div>
  );
};
